import React, { useState } from "react";
import classnames from "classnames";
import { Link } from "gatsby";
import categories from "../../content/categories";
import styles from "./MenuCategories.module.scss";

const MenuDropdownCategories = () => {
  const [opened, setOpened] = useState(false);

  return (
    <div
      onMouseEnter={() => setOpened(true)}
      onMouseLeave={() => setOpened(false)}
      className={classnames(styles.menu_item, styles.categories)}
    >
      <span onClick={() => setOpened(!opened)}>Categories</span>
      {opened && (
        <div className={styles.dropdown}>
          {categories.categories.map(cat => {
            return (
              <div key={cat.name} className={styles.itemWrapper}>
                <div className={styles.item}>
                  <Link to={cat.link} className={styles.label}>
                    {cat.label}
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MenuDropdownCategories;
